import styled from '@emotion/styled';
import { Grid, Typography } from '@mui/material';
import Image from 'next/image';
import NextLink from 'next/link';
import { useState } from 'react';
import { ClientAnalyticsEventType } from '@/components/analytics/constants';
import Button, { MidnightButton } from '@/components/button/button';
import { MediaContainer } from '@/components/media-container/media-container';
import { ExperienceFieldsFragment } from '@/generated/graphql';
import MessagePopUp from './message-popup';
import MessageIcon from '../svgs/message-icon.svg';
import PersonIcon from '../svgs/person.svg';
import { useCurrentUser } from '@/hooks/use-current-user/use-current-user';

const Host = styled(Grid)`
  height: auto;
  width: 100%;
  padding-right: 70px;
  @media (max-width: 768px) {
    padding-top: unset;
    padding-right: 0px;
  }
`;

const HostInfo = styled(Grid)`
  width: max-content;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  margin-top: -10px;
`;
const HostImage = styled(MediaContainer)`
  height: 150px;
  width: 150px;
  object-fit: cover;
  border-radius: 60% 70% 70% 60%;
  margin-top: 30px;
`;
const HostedByDiv = styled.div`
  width: 400px;
  min-height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  @media (max-width: 768px) {
    width: 100%;
  }
`;
const HostedBy = styled(Typography)`
  color: #251628;
  text-align: center;
  font-family: var(--font-work-sans);
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  margin-right: 10px;
  color: ${({ theme }) => theme.palette.common.midnight};
  @media (max-width: 768px) {
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
  }
`;
const HostBio = styled(Typography)`
  color: #251628;
  font-family: var(--font-work-sans);
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 159.3%;
  align-items: center;
  text-align: justify;
  @media (max-width: 768px) {
    padding: 0 20px;
  }
`;
const ButtonsDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 30px;
  column-gap: 16px;
  @media (max-width: 768px) {
    padding: 0 20px;
    justify-content: space-between;
  }
`;
const HostButton = styled(MidnightButton)`
  color: #ffffff;
  @media (max-width: 768px) {
  }
`;
const MessageButton = styled(Button)`
  border: #251628 solid 2px;
  color: #251628;
  background-color: transparent;
  :hover {
    color: #251628;
    border: 2px solid #251628;
    background-color: #d5d5d5;
  }
  @media (max-width: 768px) {
    padding: 12px;
  }
`;

export interface HostProfileProps {
  experience: ExperienceFieldsFragment;
}
const HostProfile = ({ experience }: HostProfileProps) => {
  //const isMobile = useMediaQuery('(max-width:768px)');
  const [messageModalOpen, setMessageModalOpen] = useState<boolean>(false);
  const hostInfo = experience?.host;
  const hostAvatar = hostInfo?.profile?.avatar?.url || '/person.png';
  const currentUser = useCurrentUser();
  const loggedIn = !!currentUser?.data?.id;
  return (
    <Host container>
      <HostInfo item>
        <HostImage>
          <Image src={hostAvatar} alt="Host Picture" fill />
        </HostImage>
        <HostedByDiv>
          <HostedBy>Your Host, {hostInfo?.profile?.nickname}</HostedBy>
        </HostedByDiv>
        <HostBio>{hostInfo?.profile?.about}</HostBio>
        <ButtonsDiv>
          <NextLink href={`/profile/${hostInfo.id}/`} passHref>
            <HostButton startIcon={<PersonIcon />}>See profile</HostButton>
          </NextLink>
          {loggedIn && (
            <MessageButton startIcon={<MessageIcon />} onClick={() => setMessageModalOpen(true)}>
              Message Host
            </MessageButton>
          )}
        </ButtonsDiv>
      </HostInfo>
      <MessagePopUp
        open={messageModalOpen}
        onClose={() => setMessageModalOpen(false)}
        hostId={hostInfo?.id}
        sentFrom={ClientAnalyticsEventType.MESSSAGE_SENT_FROM_EXPERIENCE_PAGE}
      />
    </Host>
  );
};

export default HostProfile;
